<template>
  <v-dialog v-model="dialogOpen" width="1000" @click:outside="close">
    <v-card>
      <v-card-title>Modem Replacement</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="7">
            <v-stepper v-model="step" vertical>

              <v-stepper-step editable :complete="step > 1" step="1">Replacement Reason</v-stepper-step>
              <v-stepper-content step="1">
                <v-sheet class="mx-5">
                  <v-row>
                    <v-col>
                      <v-select label="Select Replacement Type" :items="replacement_types" v-model="formData.replacement_type" hide-details outlined dense></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-select label="Select Replacement Reason" :items="replacement_reasons[formData.replacement_type]" v-model="formData.replacement_reason" :disabled="formData.replacement_type===''" hide-details outlined dense></v-select>
                    </v-col>
                  </v-row>
                  <v-btn color="primary" small @click="step=2;" :disabled="completedStep1">CONTINUE</v-btn>
                </v-sheet>
              </v-stepper-content>

              <v-stepper-step editable :complete="step > 2" step="2">Choose Hardware</v-stepper-step>
              <v-stepper-content step="2">
                <v-sheet class="mx-5">

                  <v-radio-group v-model="formData.hardware">
                    <template v-for="(item,ind) in getTelcoModemsByRouter">
                      <v-card class="mb-2" :key="ind">
                        <v-row>
                          <v-col cols="7">
                            <v-radio :label="item.text" :value="item" class="mt-2 ml-3"></v-radio>
                          </v-col>
                          <v-col cols="5">
                            <v-select label="Price" :items="item.prices" v-model="item.selectedPrice" return-object hide-details dense outlined class="mr-3"></v-select>
                          </v-col>
                        </v-row>
                      </v-card>
                    </template>
                  </v-radio-group>

                  <v-btn color="primary" small @click="step=3;" :disabled="completedStep2">CONTINUE</v-btn>
                  <v-btn color="primary" class="float-right" outlined small @click="bHive('search-query')"><v-icon small >{{bHiveIcon}}</v-icon></v-btn>
                </v-sheet>
              </v-stepper-content>

              <v-stepper-step editable :complete="step > 3" step="3">Delivery Address</v-stepper-step>
              <v-stepper-content step="3">
                <v-sheet class="mx-5">
                  <p class="mb-1 text-caption">Delivery Address <v-icon small class="ml-2" @click="deliveryAddressDialogOpen=true">edit</v-icon></p>
                  <ShowDeliveryAddress :bold="true" :address="telcoModemAddress"/>
                  <v-radio-group v-model="formData.delivery">
                    <template v-for="(item,ind) in getTelcoModemsByModemDeliveryFees">
                      <v-card class="mb-2" :key="ind">
                        <v-row>
                          <v-col cols="7">
                            <v-radio :label="item.text" :value="item" class="mt-2 ml-3"></v-radio>
                          </v-col>
                          <v-col cols="5">
                            <v-select label="Price" :items="item.prices" v-model="item.selectedPrice" return-object hide-details dense outlined class="mr-3"></v-select>
                          </v-col>
                        </v-row>
                      </v-card>
                    </template>
                  </v-radio-group>
                  <v-btn color="primary" small @click="step=4;" :disabled="completedStep3">CONTINUE</v-btn>
                </v-sheet>
              </v-stepper-content>

              <v-stepper-step step="4">Confirm Order</v-stepper-step>
              <v-stepper-content step="4">
                <v-sheet class="mx-5">
                  <p class="body--text">
                    Please make sure all information on the right is correct.
                  </p>
                  <p class="body--text">
                    Pressing "Place Order" will send an adhoc invoice to the customer and place the order immediately. You will be able to take a payment or send a payment link to the customer on the next page.
                  </p>
                  <v-checkbox v-model="consent" label="I confirm the details of the order are correct" :disabled="telcoModemUpdateLoading"></v-checkbox>
                </v-sheet>
              </v-stepper-content>

            </v-stepper>
          </v-col>
          <v-col cols="5">
            <template v-if="step>1">
              <v-row>
                <v-col>
                  <v-card>
                    <v-card-title>1. Replacement Reason</v-card-title>
                    <v-card-text>
                      <p class="body--text">{{formData.replacement_type | replacement_type}} - {{formData.replacement_reason}}</p>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </template>
            <template v-if="step>2">
              <v-row>
                <v-col>
                  <v-card>
                    <v-card-title>2. Choose Hardware</v-card-title>
                    <v-card-text>
                      <p class="body--text">{{formData.hardware.text}} - {{formData.hardware.selectedPrice.price | formatCurrency}}</p>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </template>
            <template v-if="step>3">
              <v-row>
                <v-col>
                  <v-card>
                    <v-card-title>3. Delivery</v-card-title>
                    <v-card-text>
                      <p class="body--text">{{formData.replacement_type | hourly_delivery}}</p>
                      <ShowDeliveryAddress :bold="false" :address="telcoModemAddress"/>
                      <p class="body--text">{{formData.delivery.text}} - {{formData.delivery.selectedPrice.price | formatCurrency}}</p>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </template>
            <template v-if="step>1">
              <v-row>
                <v-col>
                  <p>Total price exc. VAT <b class="float-right">{{totals.excVat | formatCurrency}}</b></p>
                  <p>VAT <b class="float-right">{{totals.vat | formatCurrency}}</b></p>
                  <p>Total price <b class="float-right">{{totals.total | formatCurrency}}</b></p>
                </v-col>
              </v-row>
            </template>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit" :disabled="disableSubmit||telcoModemUpdateLoading" :loading="telcoModemUpdateLoading">PLACE ORDER</v-btn>
        <v-btn color="primary" small outlined @click="close" :disabled="telcoModemUpdateLoading">CANCEL</v-btn>
        <v-btn color="error" small outlined @click="resetForm" :disabled="telcoModemUpdateLoading" v-if="step>1">RESET</v-btn>
      </v-card-actions>
    </v-card>
    <ModemDeliveryAddressDialog :dialogOpen="deliveryAddressDialogOpen" @close-dialog="deliveryAddressDialogOpen=false"/>
  </v-dialog>
</template>

<script>
  import ShowDeliveryAddress from './ShowDeliveryAddress';
  import ModemDeliveryAddressDialog from './ModemDeliveryAddressDialog';
  import { mdiBeehiveOutline } from '@mdi/js';
  import {mapState,mapActions,mapGetters,mapMutations} from 'vuex';
  export default {
    components: {ModemDeliveryAddressDialog,ShowDeliveryAddress},
    data() {
      return {
        bHiveIcon: mdiBeehiveOutline,
        step: 1,
        replacement_types: [{text:'Upgrade',value:'upgrade'},{text:'Fault',value:'fault'}],
        replacement_reasons: {
          upgrade:['Fibre Upgrade','Outdated','Upgrade to better router'],
          fault:['Customer damage','No auth & cannot be reconfigured','No sync','No power','Slow speeds','Dropouts','Wifi issue','Eng advised to replace'].sort(),
        },
        formData: {
          replacement_type: '',
          replacement_reason: '',
          hardware: {},
          delivery: {},
        },
        deliveryAddressDialogOpen: false,
        consent: false,
      }
    },
    filters: {
      replacement_type: (val)=>{
        let map = {upgrade:'Upgrade',fault:'Fault'};
        return map[val];
      },
      hourly_delivery: (val)=>{
        let map = {upgrade:'48-hour delivery (Upgrade)',fault:'24-hour delivery (Fault)'};
        return map[val];
      },
    },
    watch: {
      async dialogOpen(open) {
        if(open){
          await this.fetchTelcoModems();
          this.formData.delivery = this.getTelcoModemsByModemDeliveryFees[0];
        }
      },
    },
    computed: {
      ...mapState('products',['currentProduct','telcoModemAddress','telcoModemData','telcoModemUpdateLoading']),
      ...mapGetters('products',['getTelcoModemsByRouter','getTelcoModemsByModemDeliveryFees','getTelcoModemUpdate']),
      completedStep1() {
        return this.formData.replacement_type===''||this.formData.replacement_reason==='';
      },
      completedStep2() {
        let disabled = false;
        if(this.formData.hardware.text===undefined){ disabled=true;}
        return disabled;
      },
      completedStep3() {
        let isSet = false;
        isSet = (
          [null,undefined,''].indexOf(this.telcoModemAddress.line_one)===-1&&
          [null,undefined,''].indexOf(this.telcoModemAddress.city)===-1&&
          [null,undefined,''].indexOf(this.telcoModemAddress.post_code)===-1&&
          [null,undefined,''].indexOf(this.telcoModemAddress.county)===-1&&
          [null,undefined,''].indexOf(this.telcoModemAddress.country)===-1
        );
        return (!isSet);
      },
      disableSubmit() {
        let disabled = this.completedStep1;
        disabled = (!disabled)?this.completedStep2:true;
        disabled = (!disabled)?this.completedStep3:true;
        disabled = (!disabled)?!this.consent:true;
        return disabled;
      },
      totals() {
        let VAT = this.$vatAmount;
        let VAT_MULTIPLIER = this.$vatAmount + 1;
        let totals = {excVat:0,vat:0,total:0};
        if(this.formData.hardware.selectedPrice!==undefined){ totals.excVat += parseFloat(this.formData.hardware.selectedPrice.price)};
        if(this.formData.delivery.selectedPrice!==undefined){ totals.excVat += parseFloat(this.formData.delivery.selectedPrice.price)};
        totals.vat = totals.excVat * VAT;
        totals.total = totals.excVat * VAT_MULTIPLIER;
        return totals;
      },
    },
    props: ['dialogOpen'],
    methods: {
      ...mapActions('products',['fetchTelcoModems','replaceModem']),
      ...mapMutations('adhoc',['setAdhocCreateInvoiceOpen','setCurrentAdhocInvoiceLineItems','setIsModemUpdate']),
      show_delivery(bold){
        let tag = (bold)?{s:'<b>',e:'</b><br />'}:{s:'',e:'<br />'};
        let html = ``;
        html += ([null,undefined,''].indexOf(this.telcoModemAddress.line_one)===-1)?`${tag.s}${this.telcoModemAddress.line_one}${tag.e}`:``;
        html += ([null,undefined,''].indexOf(this.telcoModemAddress.line_two)===-1)?`${tag.s}${this.telcoModemAddress.line_two}${tag.e}`:``;
        html += ([null,undefined,''].indexOf(this.telcoModemAddress.city)===-1)?`${tag.s}${this.telcoModemAddress.city}${tag.e}`:``;
        html += ([null,undefined,''].indexOf(this.telcoModemAddress.post_code)===-1)?`${tag.s}${this.telcoModemAddress.post_code}${tag.e}`:``;
        html += ([null,undefined,''].indexOf(this.telcoModemAddress.country)===-1)?`${tag.s}${this.telcoModemAddress.country}${tag.e}`:``;
        html += ([null,undefined,''].indexOf(this.telcoModemAddress.county)===-1)?`${tag.s}${this.telcoModemAddress.county}${tag.e}`:``;
        if(html===''){ html = `No address selected`; }
        return html;
      },
      bHive(ext){
        window.open(`https://sites.google.com/bonline.com/bonlinecrmupdates/${ext}`);
      },
      async submit() {
        let formData = this.formData;
        let data = {
          replacement_type: formData.replacement_type.toUpperCase().replace(/ /g,'_'),
          replacement_reason: formData.replacement_reason.toUpperCase().replace(/ /g,'_'),
          modem_charge_id: formData.hardware.selectedPrice.value,
          delivery_charge_id: formData.delivery.selectedPrice.value,
          delivery_address: {
            line_one: this.telcoModemAddress.line_one,
            line_two: this.telcoModemAddress.line_two,
            city: this.telcoModemAddress.city,
            post_code: this.telcoModemAddress.post_code,
            country: this.telcoModemAddress.country,
            county: this.telcoModemAddress.county,
          },
        };
        let success = await this.replaceModem({pid:this.currentProduct.id,data:data});
        if(success){
          let objects = [this.formData.hardware,this.formData.delivery]
          let items = objects.map((item,index)=>{return {
            cat: (index===0)?'Router':'Delivery',
            id: item.selectedPrice.value,
            price: item.selectedPrice.price,
            quantity: 1,
            name: item.text,
            name: item.text,
          }});
          this.close();
          this.setIsModemUpdate(true);
          this.setCurrentAdhocInvoiceLineItems(items);
          this.setAdhocCreateInvoiceOpen(true);
        }
      },
      resetForm() {
        this.formData = {
          replacement_type: '',
          replacement_reason: '',
          hardware: {},
          delivery: {},
          modem_delivery_fee_selected: 'true',
          modem_delivery_fee: 9.99,
        };
        this.consent = false;
        this.formData.delivery = this.getTelcoModemsByModemDeliveryFees[0];
        this.step = 1;
      },
      close() {
        this.resetForm();
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped>
  .v-application--is-ltr .theme--light.v-stepper--vertical {
    .v-stepper__content {
      width: calc(100% - 40px) !important;
    }
    .v-stepper__step {
      padding: 15px;
      margin: 10px;
    }
  }
</style>
